import type { CSSProperties, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  color?: string;
  border?: string;
  onClick?: () => void;
  small?: boolean;
  padding?: number | string;
  className?: string;
  style?: CSSProperties;
  testId?: string;
  label?: string;
}

/** A rounded, softly shadowed, brightly coloured container (the building block of every screen). */
export function Bubble({ children, color, border, onClick, small, padding, className = '', style, testId, label }: Props) {
  const s: CSSProperties = { ...(color ? { background: color } : {}), ...(border ? { border } : {}), ...(padding != null ? { padding } : {}), ...style };
  const cls = `bubble${small ? ' small' : ''} ${className}`.trim();
  if (onClick) {
    return (
      <button type="button" className={cls} style={s} onClick={onClick} data-testid={testId} aria-label={label}>
        {children}
      </button>
    );
  }
  return (
    <div className={cls} style={s} data-testid={testId}>
      {children}
    </div>
  );
}
